import { Share } from '@medifind/popups';
import { Bookmark } from '@medifind/shared-basic-components';
import styles from './BoxButtons.module.scss';

const BoxButtons = ({ hideBookmark, hideShare }) => {
  return (
    <div className={styles['buttons']}>
      {!hideBookmark && <Bookmark buttonType="thin" color="darkBlue" className={styles['buttons--override']} iconOnlyAt={'xs'} />}
      {!hideShare && (
        <Share id="page-share-button" buttonType="thin" color="darkBlue" className={styles['buttons--override']} iconOnlyAt={'xs'} />
      )}
    </div>
  );
};

export { BoxButtons as default, BoxButtons };
